module.exports = __webpack_public_path__ + "static/media/jogadores.749fe047.webp";